// Dashboard shared constants — stages, stage meta, risk data, helper utils
export const stages = ['Intake', 'Drafting', 'Review', 'Pricing', 'Ready', 'Submitted'];

export const stageMeta = {
    Intake: { bg: '#EEF2F6', text: '#475467', border: '#D0D5DD', barFill: '#94A3B8' },
    Drafting: { bg: '#EEF2F6', text: '#475467', border: '#D0D5DD', barFill: '#94A3B8' },
    Progress: { bg: '#E0F2FE', text: '#0369A1', border: '#BAE6FD', barFill: '#38BDF8' },
    Generating: { bg: '#EDE9FE', text: '#6D28D9', border: '#DDD6FE', barFill: '#8B5CF6' },
    Review: { bg: '#FEF3C7', text: '#B45309', border: '#FDE68A', barFill: '#F59E0B' },
    Submitted: { bg: '#EEF2FF', text: '#4338CA', border: '#C7D2FE', barFill: '#4F46E5' },
    Accepted: { bg: '#DCFCE7', text: '#15803D', border: '#BBF7D0', barFill: '#10B981' },
    Rejected: { bg: '#FEE2E2', text: '#B91C1C', border: '#FECACA', barFill: '#EF4444' },
    Expired: { bg: '#EFF6FF', text: '#155CC0', border: '#FED7AA', barFill: '#2276E9' },
    Blocked: { bg: '#F1F5F9', text: '#475569', border: '#CBD5E1', barFill: '#64748B' },
    Finalized: { bg: '#FEF9C3', text: '#713F12', border: '#FEF08A', barFill: '#EAB308' }
};

export const risks = [
    { label: 'Compliance Risk', level: 25, color: '#10B981', tip: 'All documents verified' },
    { label: 'Deadline Risk', level: 60, color: '#D97706', tip: '2 proposals due within 5 days' },
    { label: 'Pricing Risk', level: 35, color: '#10B981', tip: 'Margins within acceptable range' },
    { label: 'Resource Load', level: 75, color: '#EF4444', tip: '3 team members overloaded' }
];

export const formatRevenue = (val) => {
    if (val === undefined || val === null) return 'AED 0';
    if (val >= 1000000) return `AED ${(val / 1000000).toFixed(1)}M`;
    if (val >= 1000) return `AED ${(val / 1000).toFixed(1)}K`;
    return `AED ${val}`;
};

export const getConfidence = (proposal) => {
    if (proposal.confidence !== undefined) return proposal.confidence;
    let hash = 0;
    const str = proposal.rfp_id || proposal.id || '';
    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    return Math.abs(65 + (hash % 30));
};

export const getAIReasoning = (proposal, index) => {
    const reasonings = [
        'Strong technical alignment — reuse 78% of standard content',
        'Compliance gap detected in Section 2 — requires SOC 2 update',
        'Budget range matches our pricing model — high alignment',
        'Review cycle 40% faster than average — on track for early submit',
        'Highest win probability in pipeline — prioritize final review',
        '3 competitors identified — consider aggressive pricing strategy'
    ];
    return reasonings[index % reasonings.length];
};

export const getStageMeta = (stageName) => {
    if (!stageName) return { ...stageMeta.Drafting, displayName: 'Draft' };
    
    let nameStr = '';
    if (typeof stageName === 'object') {
        nameStr = stageName.label || stageName.name || stageName.value || '';
    } else {
        nameStr = String(stageName);
    }
    
    if (!nameStr) return { ...stageMeta.Drafting, displayName: 'Draft' };
    
    const normalized = nameStr.toLowerCase();
    
    if (normalized.includes('final') || normalized.includes('complete')) {
        return { ...stageMeta.Finalized, displayName: 'RFP Finalized' };
    }
    if (normalized.includes('draft') || normalized.includes('intake') || normalized === '0' || normalized.includes('upload')) {
        return { ...stageMeta.Intake, displayName: 'Draft' };
    }
    if (normalized.includes('progress') || normalized.includes('assign') || normalized === '2') {
        return { ...stageMeta.Progress, displayName: 'In Progress' };
    }
    if (normalized.includes('generating') || normalized.includes('analyz') || normalized === '1') {
        return { ...stageMeta.Generating, displayName: 'AI Generating' };
    }
    if (normalized.includes('review') || normalized.includes('approval') || normalized === '3' || normalized.includes('refinement') || normalized === '11') {
        return { ...stageMeta.Review, displayName: normalized.includes('tl') ? 'Pending TL Review' : 'In Review' };
    }
    if (normalized.includes('submit') || normalized === '5' || normalized.includes('go') || normalized === '8') {
        return { ...stageMeta.Submitted, displayName: 'Submitted' };
    }
    if (normalized.includes('accept') || normalized.includes('approved') || normalized.includes('won') || normalized === '6') {
        return { ...stageMeta.Accepted, displayName: 'Approved' };
    }
    if (normalized.includes('reject') || normalized.includes('lost') || normalized === '7' || normalized.includes('no-go') || normalized === '9') {
        return { ...stageMeta.Rejected, displayName: 'Rejected' };
    }
    if (normalized.includes('expire') || normalized.includes('overdue') || normalized === '10') {
        return { ...stageMeta.Expired, displayName: 'Expired' };
    }
    if (normalized.includes('block')) {
        return { ...stageMeta.Blocked, displayName: 'Blocked' };
    }
    
    return { ...stageMeta.Drafting, displayName: nameStr };
};
